export enum GoodStatus {
  NUEVO = 'Nuevo',
  FINALIZADO = 'Finalizado',
  POR_APROBAR = 'Por aprobar',
  APROBADO = 'Aprobado',
  RECHAZADO = 'Rechazado / anulado',
  ANULADO = 'Anulado',
  POR_REGISTRAR = 'Por registrar',
}
export enum GoodTypes {
  ACTIVO_FIJO = 'Activo fijo',
  ACTIVO_FIJO_ID = 1,

  BIEN_CONSUMO = 'Bien de consumo',
  BIEN_CONSUMO_ID = 2,

}
